import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import FbHeader from '../component/FbHeader';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import foodBannerOne from "../../../assets/food/foodbanner_one.png"
import foodBannerTwo from "../../../assets/food/foodbanner_two.png"
import noImg from "../../../assets/food/foodofferimg.png"
import offerbgimg from "../../../assets/food/offerbgimg.png"
import bestoffer from "../../../assets/food/bestoffer.png"
import movie_404_miv from "../../../assets/food/movie_404_miv.jpg"
import movie_404_mih from "../../../assets/food/movie_404_mih.jpg"
import { FoodOfferCard } from '../component/FoodOfferCard';
import * as appConstants from "../../../constants/index";
import "../foodoffer.css";
import axios from 'axios';
import Navbar from 'src/views/common/navbar/Navbar';
import Cities from 'src/views/common/cities/Cities';
import { getResponsiveClasses } from '../component/ResponsiveClasses';
import SweetAlertUtility from '../component/SweetAlertUtility';
import FoodOfferSkeleton from 'src/skeletons/FoodOfferSkeleton';
import { setLoginViewMode } from 'src/redux/actions/loginViewAction';
import { useDispatch, useSelector } from 'react-redux';
import Login from 'src/views/common/login/Login';
import { Dialog } from 'primereact/dialog';
import OrderSwiper from '../component/OrderSwiper';

const FoodOffer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showOffer, setShowOffer] = useState(true);
    const [loading, setLoading] = useState(true);
    const [bannerData, setBannerData] = useState(null);
    const [offerCardData, setOfferCardData] = useState(null);
    const [storeAllOfferList, setStoreAllOfferList] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(100);
    const [activeFilter, setActiveFilter] = useState("All Vouchers");
    const [activeSlide, setActiveSlide] = useState(0);
    const [mediaDurations, setMediaDurations] = useState([]);
    const [mediaType, setMediaType] = useState([]);
    const [alertDetails, setAlertDetails] = useState({ show: false, type: "", title: "", message: "", });
    const [isHolding, setIsHolding] = useState(false);
    const [timerId, setTimerId] = useState(null);
    const [remaining, setRemaining] = useState(mediaDurations[activeSlide] || 5000);
    const [startTime, setStartTime] = useState(Date.now());
    const [navDisabled, setNavDisabled] = useState(false);

    // const sliderRef = useRef();
    const timerRef = useRef(null);
    const holdStartTimeRef = useRef(0);

    const loginVewMode = useSelector((state) => state.loginViewMode.value);
    const AuthToken = sessionStorage.getItem("token") || " ";
    const promBanner = localStorage.getItem("promBanner") || "true";
    const theme = localStorage.getItem("theme");
    const loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
    localStorage.removeItem("timerId");
    localStorage.removeItem("FoodListTimerId");
    localStorage.removeItem("FoodActivated");
    localStorage.setItem("pageName", "offerpage");
    const { currentClasses, getWindowWidth } = getResponsiveClasses();
    const filters = ["All Vouchers", "Veg", "Non-veg"];

    const handleOffertoClose = () => setShowOffer(false);

    const bestOffers = useMemo(() => offerCardData?.filter(item => item?.bestOffer) || [], [offerCardData]);

    // const cleanedOfferExisting = useCallback(() => {
    //     const currentTime = Date.now();
    //     const storeAllOfferData = JSON.parse(localStorage.getItem("storeAllOfferData")) || [];

    //     const filteredOffers = storeAllOfferData.filter(item =>
    //         new Date(item.expiryDate).getTime() > currentTime
    //     );

    //     localStorage.setItem("storeAllOfferData", JSON.stringify(filteredOffers));
    // }, []);  



    // useEffect(() => {
    //     cleanedOfferExisting();

    //     const offersInterval = setInterval(cleanedOfferExisting, 30_000);

    //     return () => {
    //         clearInterval(offersInterval);
    //     };
    // }, [cleanedOfferExisting]);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (loginInfo?.access?.token) {
            fetchOffers();
        } else {
            dispatch(setLoginViewMode({ value: true }));
        }
    }, [loginInfo?.access?.token])

    useEffect(() => {
        if (!bestOffers?.length) return;

        const durations = new Array(bestOffers.length).fill(5000);
        let videoCount = 0;
        let loadedCount = 0;

        bestOffers.forEach((item, index) => {
            if (item?.voucherImageUrl?.endsWith('.mp4')) {
                videoCount++;
                const video = document.createElement('video');
                video.src = item.voucherImageUrl;
                video.onloadedmetadata = () => {
                    durations[index] = video.duration * 1000;
                    loadedCount++;
                    if (loadedCount === videoCount) {
                        setMediaDurations([...durations]);
                    }
                };
            }
        });

        if (videoCount === 0) {
            setMediaDurations([...durations]);
        }
    }, [bestOffers]);

    useEffect(() => {
        if (isHolding || !bestOffers.length) return;

        if (activeSlide >= bestOffers.length - 1) {
            const duration = mediaDurations[activeSlide] || 5000;
            setStartTime(Date.now());

            const timer = setTimeout(() => {
                handleOffertoClose();
            }, duration);

            setTimerId(timer);
            timerRef.current = timer;

            return () => clearTimeout(timer);
        }
        const duration = mediaDurations[activeSlide] || 5000;
        setStartTime(Date.now());

        const timer = setTimeout(() => {
            setActiveSlide((prev) => prev + 1); // Move to next without loop
            setRemaining(mediaDurations[activeSlide + 1] || 5000);
        }, duration);

        setTimerId(timer);
        timerRef.current = timer;

        return () => clearTimeout(timer);
    }, [activeSlide, mediaDurations, isHolding, bestOffers.length]);

    useEffect(() => {
        let prevVoucherNos = [];
        let prevHadTheatre = false;

        const interval = setInterval(() => {
            const stored = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

            const allActivateVouchers = stored
                .filter(item => Array.isArray(item.activateVoucher) && item.activateVoucher.length > 0)
                .flatMap(item => item.activateVoucher);

            const currentVouchers = allActivateVouchers.filter(v => v.theatreId === theatreId);
            const currentVoucherNos = currentVouchers.map(v => v.voucherNo);

            const theatreMatchNow = currentVouchers.length > 0;

            const hasRemoved =
                (prevVoucherNos.length > currentVoucherNos.length && prevVoucherNos.some(v => !currentVoucherNos.includes(v))) ||
                (prevVoucherNos.length > 0 && currentVoucherNos.length === 0);

            // Decide theatre match: use previous vouchers if current is empty
            const theatreMatch = theatreMatchNow || prevHadTheatre;

            if (hasRemoved && theatreMatch) {
                setTimeout(() => {
                    console.log("Voucher removed → Fetching offers...");
                    fetchOffers();
                }, 2000);
            }

            prevVoucherNos = currentVoucherNos;
            prevHadTheatre = theatreMatchNow || prevHadTheatre;
        }, 1000);

        return () => clearInterval(interval);
    }, [theatreId]);

    const fetchOffers = async () => {
        setLoading(true);

        try {
            const response = await axios.get(
                `${appConstants.base_url}v1/jito/on-the-fly-offers?ccode=${theatreId}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`, // Make sure AuthToken is defined
                        "Content-Type": "application/json",
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                    },
                }
            );

            if (response.data.result.toLowerCase() === "success" && response?.data?.output) {

                const banners = response?.data?.output?.banners || [];
                const listData = response?.data?.output?.onTheFlyOffers || [];

                const mergedData = banners.map(banner => {
                    const matchedOffer = listData.find(item => item.voucherId === banner.voucherId);
                    return {
                        ...banner,
                        ...matchedOffer,
                    };
                });

                const newListData = listData.map(item => ({
                    ...item,
                    theatreId,
                }));

                setBannerData(mergedData);
                setOfferCardData(newListData.filter(item => item?.theatreId === theatreId));
                if (listData?.some(item => item?.bestOffer)) {
                    setShowOffer(true);
                    if (promBanner === "true")
                        localStorage.setItem("promBanner", true)
                }
                // localStorage.setItem("foodoffers", JSON.stringify(newListData));
                localStorage.setItem("cartCapacity", JSON.stringify(response?.data?.output?.cartCapacity));
                localStorage.setItem("maxActivateLimit", JSON.stringify(response?.data?.output?.maxActivateLimit));
                localStorage.setItem("redTimer", JSON.stringify(response?.data?.output?.redTimer));
            } else {
                sweetAlertWarning(response?.data?.msg);
                return;
            }
        } catch (error) {
            if (error?.response?.status === 403) navigate("/");
            console.error('Error fetching offers:', error);
        } finally {
            setLoading(false);
        }
    };

    const settingsBanner = {
        centerMode: true,
        centerPadding: '30px',
        dots: true,
        arrows: false,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const settingsPromotionBanner = {
        dots: false,
        arrows: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const sweetAlertError = (msg) => {
        setAlertDetails({
            show: true,
            type: "error",
            title: "Error!",
            message: msg,
        });
    };
    const sweetAlertWarning = (msg) => {
        setAlertDetails({
            show: true,
            type: "warning",
            title: "",
            message: msg,
        });
    };

    const hideAlert = () => {
        setAlertDetails({ show: false });
        navigate("/select-cinema-for-fnb")
    };

    const handleBannerLink = (data) => {
        if (data?.voucherDesc) {
            localStorage.setItem("foodoffers", JSON.stringify(data));
            navigate(`/redeem-offers/${data?.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`)
        }
    }

    const goToNext = () => {
        if (navDisabled) return;
        setNavDisabled(true);
        setTimeout(() => setNavDisabled(false), 300); // prevent fast clicks

        clearTimeout(timerRef.current);
        setActiveSlide((prev) => {
            const isLast = prev === bestOffers.length - 1;
            if (isLast) {
                handleOffertoClose();
                localStorage.setItem("promBanner", false);
                return prev;
            }
            const next = (prev + 1) % bestOffers.length;
            setRemaining(mediaDurations[next] || 5000);
            return next;
        });
    };

    const goToPrev = () => {
        if (navDisabled) return;
        setNavDisabled(true);
        setTimeout(() => setNavDisabled(false), 300);

        clearTimeout(timerRef.current);
        setActiveSlide((prev) => {
            const next = (prev - 1 + bestOffers.length) % bestOffers.length;
            setRemaining(mediaDurations[next] || 5000);
            return next;
        });
    };

    const handleHoldStart = () => {
        holdStartTimeRef.current = Date.now();
        setIsHolding(true);
        clearTimeout(timerRef.current);
    };

    const handleHoldEnd = (direction) => {
        const holdDuration = Date.now() - holdStartTimeRef.current;
        setIsHolding(false);
        if (holdDuration < 200) {
            direction === "left" ? goToPrev() : goToNext();
        } else {
            timerRef.current = setTimeout(() => {
                goToNext();
            }, remaining);
        }
    };

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    // const handleRedirection = (item) => {
    //     if (item.active) {
    //         localStorage.setItem("FoodListTimerId", JSON.stringify(item))
    //         navigate("/offeractivated");
    //     } else {
    //         localStorage.setItem("foodoffers", JSON.stringify(item));
    //         navigate(`/redeem-offers/${item?.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`);
    //     }
    // }

    const handleRedirection = (item) => {
        if (item.active) {

            const selectedTheater = JSON.parse(localStorage.getItem("selectedTheater")) || [];
            const activateParameter = [{
                activatedDate: item.purchaseDate,
                errorMsg: "",
                expiryDate: item.expDate,
                // purchaseDate: item.purchaseDate,
                voucherDesc: item.voucherDesc,
                voucherId: item.voucherId,
                voucherNo: item.voucherNo,
                voucherStatus: 0,
                // voucherRedeemed: item.voucherStatus,
                theatreId: parseInt(selectedTheater.theatreId),
                theatreName: selectedTheater.name
            }];


            localStorage.setItem("FoodListTimerId", JSON.stringify(activateParameter))
            navigate("/offeractivated");
        } else {
            localStorage.setItem("foodoffers", JSON.stringify(item));
            navigate(`/redeem-offers/${item.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`);
        }
    }
    return (
        <>
            <div className='foodOfferPage'>
                <FbHeader
                    className="offerNav"
                    headname={loginInfo?.data?.un ? `Hey, ${loginInfo?.data?.un}` : `Hey!`}
                    locationNameModal={false}
                    cartShow={true}
                    searchShow={false}
                    addressShow={true}
                />
                {loading ? (
                    <FoodOfferSkeleton />
                ) : (
                    <>
                        {bannerData?.length > 0 &&
                            <section className='offerbanner'>
                                <h3>OFFERS</h3>
                                <p> Fresh offers, daily! Snag the best value and product deals. </p>
                                <Slider className='foodBannerSlider' {...settingsBanner}>
                                    {bannerData?.map((banner) => (
                                        <div onClick={() => handleBannerLink(banner)} key={banner?.voucherNo} id={banner?.voucherDesc} className='foodSliderli'>
                                            <img src={banner?.imageUrl || movie_404_mih} width="100%" alt="Banner" />
                                        </div>
                                    ))}
                                </Slider>
                            </section>
                        }
                        <section className='foodCardMain'>
                            {/* <ul className='flterFlx'>
                                {filters.map((filter) => (
                                    <li
                                        key={filter}
                                        className={activeFilter === filter ? 'active' : ''}
                                        onClick={() => setActiveFilter(filter)}
                                    >
                                        {filter}
                                    </li>
                                ))}
                            </ul> */}
                            {offerCardData?.length > 0 && (
                                <>
                                    <div className='foodCard'>
                                        <FoodOfferCard
                                            // key={item.voucherId}
                                            // id={item.voucherId}
                                            // link={`/redeem-offers/${item.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase()}`}
                                            // image={item.voucherImageUrl}
                                            // title={item.voucherDesc}
                                            // validity={item.validTill}
                                            // voucherNo={item?.voucherNo}
                                            className="offersPg"
                                            data={offerCardData}
                                            cartPage={true}
                                        />

                                    </div>
                                    <p className='offerend'>That's all we've got!<br /> Please keep checking for new offers.</p>
                                </>
                            )}
                        </section>
                    </>
                )}
            </div>

            {bestOffers.length > 0 && promBanner === "true" && (
                <Modal
                    className={`fullPageModal ofrmdl`}
                    show={showOffer}
                    onHide={handleOffertoClose}
                    animation
                    keyboard={false}
                    style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
                >
                    <svg className='clsbtn' width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleOffertoClose}>
                        <path d="M11.7346 1.83984L1.03125 12.1114" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.03125 1.83984L11.7346 12.1114" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    <div className="promotion-banner">
                        {/* Progress Bars */}
                        <div className="progress-bar-wrapper">
                            {bestOffers.map((_, index) => (
                                <div key={index} className="progress-bar-container">
                                    <div
                                        className={`progress-bar ${index === activeSlide ? 'animate' : ''} ${isHolding ? 'paused' : ''}`}
                                        style={{ animationDuration: `${mediaDurations[index] || 5000}ms` }}
                                    />
                                </div>
                            ))}
                        </div>

                        {/* Navigation (hold) */}
                        <div className="custom-nav-overlay">
                            <div
                                className="nav-area left"
                                onTouchStart={handleHoldStart}
                                onTouchEnd={() => handleHoldEnd("left")}
                                onMouseDown={handleHoldStart}
                                onMouseUp={() => handleHoldEnd("left")}
                            />
                            <div
                                className="nav-area right"
                                onTouchStart={handleHoldStart}
                                onTouchEnd={() => handleHoldEnd("right")}
                                onMouseDown={handleHoldStart}
                                onMouseUp={() => handleHoldEnd("right")}
                            />
                        </div>

                        {/* Media Display */}
                        <div className="promotion-container">
                            {bestOffers[activeSlide]?.bestOfferUrl?.endsWith('.mp4') ? (
                                <video
                                    key={bestOffers[activeSlide]?.voucherNo}
                                    src={bestOffers[activeSlide]?.bestOfferUrl}
                                    className="promotion-image"
                                    width="100%"
                                    autoPlay
                                    muted
                                />
                            ) : (
                                <img
                                    src={bestOffers[activeSlide]?.bestOfferUrl || movie_404_miv}
                                    className="promotion-image"
                                    width="100%"
                                    alt="Promotion"
                                />
                            )}
                            <div className="prmbtn">
                                <div
                                    className="mdbtn"
                                    onClick={() => handleRedirection(bestOffers[activeSlide])}
                                >
                                    EXPLORE
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}

            <div className="">
                <Dialog
                    header=""
                    visible={loginVewMode}
                    showHeader={false}
                    showCloseIcon={false}
                    onHide={() => dispatch(setLoginViewMode({ value: false }))}
                    className="register-mobile"
                    blockScroll={true}
                >
                    <div className="row">
                        <Login />
                    </div>
                </Dialog>
            </div>
            <OrderSwiper orderFnb={false} pageName="offerPage" APIStatus={fetchOffers} />

            <SweetAlertUtility
                type={alertDetails.type}
                title={alertDetails.title}
                message={alertDetails.message}
                show={alertDetails.show}
                onConfirm={hideAlert}
            />
        </>
    )
}

export default FoodOffer
